module.exports = __webpack_public_path__ + "img/judges.a806cda9.jpg";